import React from "react";
import { NavLink } from "react-router-dom";
import json_navbar from "./Navbar.json";
import "./Navbar.css";

const Navbar = (props) => {
  let lang = props.lang;
  return (
    <nav className="navbar">
      <NavLink
        exact
        to="/"
        activeClassName="navbar__link--active"
        className="navbar__link"
      >
        {json_navbar.actual[lang]}
      </NavLink>
      <NavLink
        to="/About"
        activeClassName="navbar__link--active"
        className="navbar__link"
      >
        {json_navbar.about[lang]}
      </NavLink>
      <NavLink
        to="/Discography"
        activeClassName="navbar__link--active"
        className="navbar__link"
      >
        {json_navbar.discography[lang]}
      </NavLink>
      <NavLink
        to="/Concerts"
        activeClassName="navbar__link--active"
        className="navbar__link"
      >
        {json_navbar.concerts[lang]}
      </NavLink>
      <NavLink
        to="/Photogallery"
        activeClassName="navbar__link--active"
        className="navbar__link"
      >
        {json_navbar.photos[lang]}
      </NavLink>
      <NavLink
        to="/Service"
        activeClassName="navbar__link--active"
        className="navbar__link"
      >
        {json_navbar.service[lang]}
      </NavLink>
      <NavLink
        to="/Contacts"
        activeClassName="navbar__link--active"
        className="navbar__link"
      >
        {json_navbar.contacts[lang]}
      </NavLink>
    </nav>
  );
};

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/UI/Navbar/Navbar.jsx